import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { PlaceLocationPinIcon, getPlaceIcon } from 'features/mapping/icons';
import { PlaceIcon } from 'features/places/places.types';

type LocationMarkerProps = {
  name: string;
  placeIcon?: PlaceIcon;
};

const useStyles = makeStyles()((theme) => ({
  container: {
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    containerType: 'inline-size',
  },
  pinContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  placeLabelContainer: {
    position: 'absolute',
    top: '90%',
    width: 'max-content',
    // `100cqw` is the map's width; `100%` would be the pin's.
    maxWidth: 'min(300px, 100cqw)',
    paddingTop: 3,
  },
  placeLabel: {
    color: theme.palette.grey[800],
    textShadow:
      '2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff, 1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff',
    fontWeight: 600,
  },
}));

export const LocationMarker = (props: LocationMarkerProps): JSX.Element => {
  const { name, placeIcon } = props;
  const { classes } = useStyles();

  const icon = placeIcon ? getPlaceIcon(placeIcon) : null;

  return (
    <div className={classes.container}>
      <div className={classes.pinContainer}>
        <img
          src={PlaceLocationPinIcon.data}
          width={PlaceLocationPinIcon.width}
          height={PlaceLocationPinIcon.height}
          alt="location marker"
        />
        {icon && (
          <>
            <img
              src={icon.data}
              alt={name}
              width={icon.width}
              height={icon.height}
              style={{
                position: 'absolute',
                left: `calc(50% - ${icon.width / 2}px)`,
                top: `calc(50% - ${icon.height * 0.85}px)`,
              }}
            />

            <div className={classes.placeLabelContainer}>
              <Typography noWrap className={classes.placeLabel}>
                {name}
              </Typography>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
